__turbopack_context__.v({
  "body-section": "p1dq5q_body-section",
  "body-text-section": "p1dq5q_body-text-section",
  "hero-section": "p1dq5q_hero-section",
  "item": "p1dq5q_item",
  "table-custom": "p1dq5q_table-custom",
  "vertical-menu": "p1dq5q_vertical-menu",
});
